import { ASSETS_API_URL } from "config/api";
import { showApiError } from "config/apiToast";
import { getApiErrorMessages } from "config/apiErrors";
import React, { useEffect, useState } from "react";
import "./dashboard.scss";
import { Modal, Nav, Pagination } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(10); // Set the limit per page
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const getData = async (page, limit) => {
    const tok = localStorage.getItem("accessTokenDash");
    setTasks([]);
    setLoading(true);
    setLoadError("");
    
    var config = {
      method: "get",
      url: `${ASSETS_API_URL}/chains?page=${page}&limit=${limit}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };
    
    axios(config)
      .then(function (response) {
        setTasks(response?.data?.data || []); // Assuming the tasks array is nested inside data
        setTotalPages(response?.data?.pagination?.pageCount || 1); // Assuming the total page count is returned
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        setLoadError(getApiErrorMessages(error).join(" "));
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const deleteToken = async (id) => {
    console.log(id)
    const tok = localStorage.getItem("accessTokenDash");
    // setTasks([]);

    var config = {
      method: "delete",
      url: `${ASSETS_API_URL}/chains/${id}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };

    axios(config)
      .then(function (response) {
        console.log("responce",response)
        getData(currentPage, itemsPerPage);
        // setTasks(response?.data?.data); // Assuming the tasks array is nested inside data
        // setTotalPages(response?.data?.pagination?.pageCount); // Assuming the total page count is returned
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        showApiError(error);
      });
  };

  useEffect(() => {
    getData(currentPage, itemsPerPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <img className="elipse img-fluid" src="\assets\main-assets\Ellipse.png" />
      <div className="content">
        <div className="maintablea_task">
          <div className="table-responsive maintable">
            <table>
              <thead>
                <tr>
                  <th>Token</th>
                  <th>Chain ID</th>
                  <th>isEnabled</th>
                  <th>isEssential</th>
                  <th>Details</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr><td colSpan="5"><p className="white">Loading chains...</p></td></tr>
                )}
                {!loading && loadError && (
                  <tr><td colSpan="5"><p className="error">{loadError}</p></td></tr>
                )}
                {!loading && !loadError && tasks?.length === 0 && (
                  <tr><td colSpan="5"><p className="white">No chains found.</p></td></tr>
                )}
                {tasks.map((task) => (
                  <tr key={task.id}>
                    <td>
                      <div className="para11">
                        <img className="edfeveerverre img-fluid" src={task?.logo} alt={task.name} />
                        {task.name}
                      </div>
                    </td>
                    <td className="tdofbtcc">{task.chainId}</td>
                    <td>
                      {task?.isEnabled ? <p className="yesclass1">Yes</p> : <p className="yesclass2">No</p>}
                    </td>
                    <td>
                      {task?.isEssential ? <p className="yesclass1">Yes</p> : <p className="yesclass2">No</p>}
                    </td>
                    <td>
                      <Link to={`tokendetails?ids=${task?.id}`}>
                        <button className="dettailsbut">Details</button>
                      </Link>
                    </td>
                    {/* <td>
                        <button onClick={() => deleteToken(task?.id)}  className="dettailsbut">Delete</button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="Paginationlattable">
              <div>
                <p className="showclasss">
                  SHOWING {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, tasks.length)} OF {tasks.length}
                </p>
              </div>
              <div className="pagitwo">
                <button className="leftpigbtn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      d="M10 13L5 8L10 3"
                      stroke="#565656"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <Pagination>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
                      {index + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
                <button className="leftpigbtnn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      d="M5 13L10 8L5 3"
                      stroke="#565656"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
